import deepFreeze from 'deep-freeze-strict';
import { lowerFirst, map, transform } from 'lodash';
import { type } from '@mews-framework/utils';
import ContainerConfiguration from './containerConfiguration';

export default function Container(containerConfiguration: $TSFixMe) {
    type.check(containerConfiguration, ContainerConfiguration);

    const { components } = containerConfiguration;
    const instances = {};

    const container = Object.create(Container.prototype);

    /**
     * This creates property getters on lowerFirst component type names
     * i.e if `DummyType` was registered in configuration, then `container.dummyType` will be
     * lazy-evalued getter for according component.
     */
    const componentsDescriptor = transform(
        components,
        (acc, c, componentType) => {
            // @ts-expect-error $TSFixMeError: Argument of type 'number' is not assignable to parameter of type 'string'.
            const lowerFirstType = lowerFirst(componentType);
            acc[lowerFirstType] = { get: () => get(componentType) };
        },
        {}
    );
    // @ts-expect-error $TSFixMeError: Argument of type 'Dictionary<unknown>' is not assignable to parameter of type 'PropertyDescriptorMap & ThisType<any>'.
    Object.defineProperties(container, componentsDescriptor);

    return deepFreeze(container);

    function get(componentType: $TSFixMe) {
        // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        if (!instances[componentType]) {
            const component = components[componentType];
            const dependencies = map(component.dependencyTypes, (t) => get(t));
            const instance = component.component(...dependencies, ...component.params);

            if (!type.is(instance, component.component)) {
                throw new Error(`Component is not of registered type: '${componentType}'`);
            }
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            instances[componentType] = instance;
        }
        // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        return instances[componentType];
    }
}
